module.exports = __webpack_public_path__ + "img/delete.2ec279e2.svg";